import { scheduleToast } from '@app/components/Toast';

import { type Handler, defaultFinishedAction, defaultUpdateAction } from './common';

const handler: Handler = {
    onProgress(payload, toastId, initial) {
        const keyCount = payload.bulk?.keyCount ?? 0;
        if (!keyCount) {
            return;
        }

        defaultUpdateAction(toastId, 'Pseudolocalization in progress...', payload.progress, keyCount, initial);
    },
    onFinished(payload, isOnProjectPage) {
        defaultFinishedAction(
            isOnProjectPage,
            'Pseudolocalization is complete',
            payload.params.project_id,
            payload.params.branch_name,
        );
    },
    onEarlyFinish() {
        scheduleToast({
            type: 'success',
            title: 'Pseudolocalization is complete',
            description: 'See details in project activity',
        });
    },
};

export default handler;
